import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { RenderWYSIWYG } from 'Components/Form';
import Auth from 'Components/Layouts/Auth';
import AddToCalendar from 'Pages/Agenda/AddToCalendar';
import React from 'react';

import { Loading, Alert } from 'Components/Partials';
import { PrimaryButton, DangerButton, SecondaryButton } from 'Components/Button';
import { ModalTrigger } from 'Components/Modal';
import { asset } from 'Services/BaseHelpers';
import { translationFromJson } from 'Services/TranslationHelpers2';

import AddToCalendarModal from './AddToCalendarModal';

import AgendaApi from 'Services/Api/Agenda/Agenda';
import { Toast } from 'Services';
import { translation } from 'Services/TranslationHelpers';
import { resourceDateIsBeforeNow, resourceDateIsAfterNow, dateToString } from 'Services/DateHelpers';

import User from "Services/User";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";

export default class AgendaIndex extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        alert: null,
        agendas: null,
        dates: null,
        active_date: null,
        refresh_time: null,
        showCals: false,
        expanded: {},
        last_date: null
    };
    last_date = null;

    agendaRefs = {};

    /**
     * @method componentDidMount
     */
    async componentDidMount() {
        await this.getAgenda();

        // Rerender every 60 seconds in order to keep the action buttons in sync.
        this.refreshInterval = setInterval(() => this.setState({ refresh_time: Date.now() }), 60000);
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        clearInterval(this.refreshInterval);
    };

    toggleAgenda = (id) => {
        const { expanded } = this.state;

        expanded[id] = !expanded[id];

        this.setState({
            expanded,
        });
    };

    /**
     * @method getAgenda
     */
    getAgenda = async () => {
        this.setState({
            loading: true,
        });

        const request = await AgendaApi.get(null);

        if (request.success) {
            // Get all dates.
            const dates = [...new Set(
                request.data.data.map(agenda => agenda.start_date_time.date_timezone),
            )];

            return this.setState({
                loading: false,
                agendas: request.data.data,
                dates,
                active_date: this.state.active_date ?? dates[0],
            });

            // TODO scroll back to where they were on the page.
        }

        Toast.error();
    };

    /**
     * @method addToAgenda
     * @param {string} agenda_id
     */
    addToAgenda = async (agenda_id) => {
        this.setState({
            loading: true,
            alert: null,
        });

        const response = await AgendaApi.post(null, { agenda_id });

        if (response.success) {
            this.setState({
                alert: {
                    type: 'success',
                    message: response.data.message,
                },
            });

            return this.getAgenda();
        }

        this.setState({
            alert: {
                type: 'error',
                ...response,
            },
            loading: false,
        }, () => {
            document.getElementById('alert').scrollIntoView();
        });
    }

    /**
     * @method removeFromAgenda
     * @param {string} agenda_id
     */
    removeFromAgenda = async (agenda_id) => {
        this.setState({
            loading: true,
            alert: null,
        });

        const response = await AgendaApi.delete(agenda_id);

        await this.getAgenda();
    }

    /**
     * @method showAddToAgendaButton
     * @param {object} agenda
     * @return {boolean}
     */
    showAddToAgendaButton = (agenda) => {
        if (agenda.show_add_to_agenda_button === true) {
            // If dates are null then show.
            if (agenda.show_add_to_agenda_button_start_date_time === null
                && agenda.show_add_to_agenda_button_end_date_time === null) {

                return true;
            }

            if (agenda.show_add_to_agenda_button_start_date_time === null) {
                return resourceDateIsAfterNow(agenda.show_add_to_agenda_button_end_date_time);
            }

            if (agenda.show_add_to_agenda_button_end_date_time === null) {
                return resourceDateIsBeforeNow(agenda.show_add_to_agenda_button_start_date_time);
            }

            return (resourceDateIsBeforeNow(agenda.show_add_to_agenda_button_start_date_time)
                && resourceDateIsAfterNow(agenda.show_add_to_agenda_button_end_date_time));
        }

        return false;
    }

    /**
     * @method showJoinLink
     * @param {object} agenda
     * @return {boolean}
     */
    showJoinLink = (agenda) => {
        if (agenda.join_link) {
            // If dates are null then show.
            if (agenda.join_link_display_start_date_time === null
                && agenda.join_link_display_end_date_time === null) {

                return true;
            }

            if (agenda.join_link_display_start_date_time === null) {
                return resourceDateIsAfterNow(agenda.join_link_display_end_date_time);
            }

            if (agenda.join_link_display_end_date_time === null) {
                return resourceDateIsBeforeNow(agenda.join_link_display_start_date_time);
            }

            return (resourceDateIsBeforeNow(agenda.join_link_display_start_date_time)
                && resourceDateIsAfterNow(agenda.join_link_display_end_date_time));
        }

        return false;
    }

    header = () => (
        <div className="h-banner bg-banner-agenda bg-no-repeat bg-cover bg-right relative">
            <div className="absolute h-full w-full flex">
                <span className="m-auto text-app-green-banner text-4xl font-gilroy">Agenda</span>
            </div>
            <img alt="" src={asset('/images/pages/agenda/agenda-banner.svg')}
                 className="max-h-banner hidden md:block h-full px-2 md:px-4 lg:px-6  py-5 lg:mt-0"
            />
        </div>
    );

    /**
     * @method render
     * @return {*}
     */
    render() {
        const { loading, alert, agendas, showCals, active_date } = this.state;
        const { remoteControlSession } = this.props;

        return (
            <Auth customHeader={remoteControlSession ? true : this.header()}  showNav={!remoteControlSession}>
                <div className="p-4 text-center">

                    <div className="mb-6 relative inline-block text-left">
                        <div className="text-center max-w-4xl mx-auto">
                            <div className="text-lg md:text-xl mb-5">
                                Please see below the agenda for the S224 Launch Event.
                            </div>

                            {/*<AddToCalendar
                                actualDropdown
                                filename="s1-24-event"
                                event={{
                                    title: 'S124 Launch Event.',
                                    timezone: 'Europe/London',
                                    location: window.location.origin,
                                    startTime: '2023-04-25T09:00Z',
                                    endTime: '2023-04-27T12:00Z',
                                    description: 'The S1 2024 launch will take place on the 25-27th April 2023, please see the registration site for more details',
                                }}
                            />*/}
                        </div>

                        {/*    <div>*/}
                        {/*        <button type="button"*/}
                        {/*                className="inline-flex justify-center bg-app-red ml-auto rounded-full px-3 md:px-5 lg:px-8 text-white py-2"*/}
                        {/*                id="options-menu" onClick={() => this.setState({showCals: !showCals})}>*/}
                        {/*            Add to calendar*/}
                        {/*            <svg className="-mr-1 ml-2 h-5 w-5 my-auto" xmlns="http://www.w3.org/2000/svg"*/}
                        {/*                 viewBox="0 0 20 20" fill="currentColor">*/}
                        {/*                <path fillRule="evenodd"*/}
                        {/*                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"*/}
                        {/*                      clipRule="evenodd"/>*/}
                        {/*            </svg>*/}
                        {/*        </button>*/}
                        {/*    </div>*/}

                        {/*    <Transition show={showCals}*/}
                        {/*                enter="transition ease-out duration-100"*/}
                        {/*                enterFrom="transform opacity-0 scale-95"*/}
                        {/*                enterTo="transform opacity-100 scale-100"*/}
                        {/*                leave="transition ease-in duration-75"*/}
                        {/*                leaveFrom="transform opacity-100 scale-100"*/}
                        {/*                leaveTo="transform opacity-0 scale-95"*/}
                        {/*    >*/}
                        {/*        <div*/}
                        {/*            className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"*/}
                        {/*            role="menu" aria-orientation="vertical" aria-labelledby="options-menu">*/}
                        {/*            <div className="py-1" role="none">*/}
                        {/*                <a href="/ics/americas.ics"*/}
                        {/*                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"*/}
                        {/*                   role="menuitem">Americas</a>*/}
                        {/*                <a href="/ics/aspac.ics"*/}
                        {/*                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"*/}
                        {/*                   role="menuitem">ASPAC</a>*/}
                        {/*                <a href="/ics/emea.ics"*/}
                        {/*                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"*/}
                        {/*                   role="menuitem">EMEA</a>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*    </Transition>*/}
                    </div>

                    {loading && <Loading />}

                    {!loading &&
                        <div>
                            {alert &&
                                <div className="px-8 py-4 mx-auto" id="alert">
                                    <Alert {...alert} />
                                </div>
                            }

                            {!agendas || agendas.length === 0 &&
                                <p className="font-bold">
                                    {translation('misc', 'no_items', {
                                        ITEM: translation('agenda', 'agenda'),
                                    })}
                                </p>
                            }
                            {this.renderDates()}
                            {agendas && agendas.length !== 0 &&
                                <div className={"bg-app-gray py-5"}>
                                    {/*{this.renderDates()}*/}
                                    <div className={"flex flex-row p-5"}>
                                        <div className="text-xs lg:text-xl w-1/3 lg:w-2/12 text-center">
                                            <span className="py-2 text-center border-app-red border-2 rounded-3xl px-1 lg:px-3 bg-white text-black font-gilroy">
                                                Start Time
                                            </span>
                                        </div>

                                    </div>
                                    {agendas && agendas.length !== 0 && <div>
                                        {agendas.filter(agenda => agenda.start_date_time.date_timezone === active_date).map(this.renderAgenda)}
                                    </div>}
                                </div>
                            }
                        </div>
                    }
                </div>
            </Auth>
        );
    }

    /**
     * @method renderDates
     * @return {*}
     */
    renderDates() {
        const { dates, active_date } = this.state;

        return (
            <div className={'flex flex-col md:flex-row mx-auto my-8 justify-center'}>
                {dates && dates.map((date, i) => {
                    return (
                        <button
                            key={i}
                            onClick={() => this.setState({ active_date: date })}
                            className={`
                                my-2 md:mx-4 py-4 px-8 rounded
                                ${active_date === date ?
                                'bg-white text-black font-gilroy border-app-red border-2'
                                : 'bg-app-red text-white hover:bg-app-gray hover:text-black'
                            }
                            `}
                        >
                            {dateToString(date)}
                        </button>
                    )
                })}
            </div>
        );
    }

    setAgendaRef = (agenda, el) => {
        this.agendaRefs[agenda.id] = el;
        this.setElementHeight(agenda.id);
    }

    setElementHeight = (id) => {
        const el = this.agendaRefs[id];

        if (el !== null) {
            el.style.setProperty('--max-height', el.children[0].clientHeight + 'px');
            el.style.setProperty('--overflow', 'hidden');
        }
    }

    /**
     * @method renderAgenda
     * @property {object} agenda
     * @return {*}
     */
    renderAgenda = (agenda, index) => {
        const { expanded, last_date} = this.state;

        const open = expanded[agenda.id];
        const translateTitle = translationFromJson(agenda.title).toLowerCase();
        const agendaClass = `${open ? 'max-h-var' : 'max-h-0'} mt-2 overflow-var transition-all duration-500`;
        const bgClass = `${(translateTitle === 'lunch' || translateTitle === 'break')  ? 'text-white bg-app-red uppercase' : 'bg-app-gray border-b-2 border-app-red mt-3'} flex flex-row text-left p-5 first:mt-0`;
        const formatted_date = new DateTime.fromISO(agenda.start_date_time.iso_string).toFormat("h a") ?? 'n/a';


        const show_date = index === 0;


        return (
            <div key={agenda.id} className={bgClass} >
                <div className="text-md lg:text-lg w-1/3 lg:w-2/12 text-center font-gilroy">
                    {show_date && (
                        <span className="py-2 text-center">
                            {formatted_date}
                        </span>
                    )}
                </div>

               <div className=" text-md lg:text-xl w-2/3 lg:w-10/12 text-center font-gilroy">
                    <div className="" onClick={() => this.toggleAgenda(agenda.id)}>
                        {translateTitle}

                        {agenda.content && translationFromJson(agenda.content) && (
                            <>
                                <span className="py-2 inline-block w-20 text-sm">
                                    View {expanded[agenda.id] ? 'less' : 'more'}
                                </span>

                                <span className="bg-app-red inline-block rounded-full text-sm w-7 h-7 text-white text-center ml-2">
                                    <FontAwesomeIcon icon={faChevronRight} className={
                                        `transition duration-300 mt-1.5 ${expanded[agenda.id] ? 'transform rotate-90' : ''}`
                                    } />
                                </span>
                                </>
                            )}
                    </div>

                    {agenda.content && translationFromJson(agenda.content) && (
                        <RenderWYSIWYG
                            className={"text-white text-sm font-medium  text-center"}
                            content={ !expanded[agenda.id] ? null : translationFromJson(agenda.content)   }
                        />
                    )}
                </div>

                {/*{(agenda.content && translationFromJson(agenda.content) || (agenda.presenters && translationFromJson(agenda.presenters)) || agenda.speakers) && <>*/}
                {/*    <div className="mt-2" onClick={() => this.toggleAgenda(agenda.id)}>*/}
                {/*        <span className="py-2 inline-block w-20">*/}
                {/*            View {expanded[agenda.id] ? 'less' : 'more'}*/}
                {/*        </span>*/}

                {/*        <span className="bg-app-red inline-block rounded-full w-7 h-7 text-white text-center ml-2">*/}
                {/*            <FontAwesomeIcon icon={faChevronRight} className={*/}
                {/*                `transition duration-300 mt-1.5 ${expanded[agenda.id] ? 'transform rotate-90' : ''}`*/}
                {/*            } />*/}
                {/*        </span>*/}
                {/*    </div>*/}

                {/*    <div ref={ref => this.setAgendaRef(agenda, ref)} className={agendaClass}>*/}
                {/*        <div>*/}
                {/*            <RenderWYSIWYG content={translationFromJson(agenda.content)} />*/}
                {/*            <RenderWYSIWYG content={translationFromJson(agenda.presenters)} />*/}

                {/*            {agenda.speakers.length > 0 && <div className="mt-6 md:mt-12 grid md:grid-cols-2 md:gap-3">*/}
                {/*                {agenda.speakers.map((speaker, k) => (*/}
                {/*                    <div key={k}*/}
                {/*                         className="flex flex-col sm:flex-row md:flex-col lg:flex-row mt-3 md:mt-0">*/}
                {/*                        <div className="flex-1 w-1/2 lg:w-full mx-auto">*/}
                {/*                            <img alt="" src={speaker.avatar_path_url} onLoad={() => {*/}
                {/*                                this.setElementHeight(agenda.id);*/}
                {/*                            }} />*/}
                {/*                        </div>*/}
                {/*                        <div className="flex flex-col flex-1 sm:ml-3">*/}
                {/*                            <h1 className="text-3xl text-black">*/}
                {/*                                {speaker.full_name}*/}
                {/*                            </h1>*/}
                {/*                            <h2 className="text-2xl text-app-red">*/}
                {/*                                {speaker.job_title}*/}
                {/*                            </h2>*/}
                {/*                            <p style={{ whiteSpace: 'break-spaces' }}>*/}
                {/*                                {speaker.speaker_bio}*/}
                {/*                            </p>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                ))}*/}
                {/*            </div>}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</>}*/}
            </div>
        );
    }

    /**
     * @method renderAgendaActions
     * @param {object} agenda
     * @return {*}
     */
    renderAgendaActions(agenda) {
        return (
            <div className="flex flex-col">
                {this.showAddToAgendaButton(agenda) &&
                    this.renderAddToAgendaButton(agenda)
                }

                {(agenda.show_add_to_calendar_button &&
                        (agenda.show_add_to_calendar_button_only_if_in_agenda === false || agenda.in_my_agenda)) &&
                    this.renderAddToCalendarButton(agenda)
                }

                {(this.showJoinLink(agenda) &&
                        (agenda.join_link_display_only_if_in_agenda === false || agenda.in_my_agenda)) &&
                    this.renderJoinLinkButton(agenda)
                }
            </div>
        );
    }

    /**
     * @method renderAddToAgendaButton
     * @param {object} agenda
     * @return {*}
     */
    renderAddToAgendaButton(agenda) {
        let text = null;
        let onClickMethod = null;
        let Component = null;

        if (agenda.in_my_agenda) {
            text = translation('agenda', 'remove_from_your_agenda');
            onClickMethod = 'removeFromAgenda';
            Component = DangerButton;
        } else if (agenda.in_my_waiting_list) {
            text = translation('agenda', 'remove_from_waitlist');
            onClickMethod = 'removeFromAgenda';
            Component = DangerButton;
        } else {
            if (!agenda.spaces || agenda.available_spaces > 0) {
                text = translation('agenda', 'add_to_your_agenda');
                onClickMethod = 'addToAgenda';
                Component = PrimaryButton;
            } else if (agenda.spaces && agenda.available_spaces < 1 && agenda.waiting_list) {
                text = translation('agenda', 'add_to_waitlist');
                onClickMethod = 'addToAgenda';
                Component = PrimaryButton;
            } else {
                text = translation('agenda', 'session_is_fully_booked_short');
                onClickMethod = null;
                Component = DangerButton;
            }
        }

        return (
            <div className="my-2">
                <Component
                    text={text}
                    onClick={() => onClickMethod ? this[onClickMethod](agenda.id) : null} />
            </div>
        );
    }

    /**
     * @method renderAddToCalendarButton
     * @param {object} agenda
     * @return {*}
     */
    renderAddToCalendarButton(agenda) {
        return (
            <div className="my-2">
                <ModalTrigger
                    component={AddToCalendarModal}
                    props={{
                        agenda,
                    }}
                >
                    <SecondaryButton text={translation('agenda', 'add_to_calendar')} />
                </ModalTrigger>
            </div>
        );
    }

    /**
     * @method renderJoinLinkButton
     * @param {object} agenda
     * @return {*}
     */
    renderJoinLinkButton(agenda) {
        return (
            <a href={agenda.join_link} target="_blank" className="my-2">
                <PrimaryButton text={translation('agenda', 'join')} />
            </a>
        );
    }

    /**
     * @method renderSpacesColumn
     * @param {object} agenda
     * @return {*}
     */
    renderSpacesColumn(agenda) {
        return (
            <span className="font-bold">
                {agenda.spaces &&
                    <>
                        {agenda.available_spaces === 1 ?
                            translation('agenda', '1_space_available') :
                            agenda.available_spaces + ' ' + translation('agenda', 'spaces_available')}
                    </>
                }

                {!agenda.spaces &&
                    <>
                        {translation('agenda', 'no_limit')}
                    </>
                }
                </span>
        );
    }
}
